import { inject, observer } from "mobx-react";
import React from "react";
import { Deliverable, Item, Question, Space } from "src/models";
import { Button, Checkbox, MultiSelect, Text } from "src/components";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { QuestionStore, SpaceStore, AuthStore, DeliverableStore } from "src/stores";
import { DataType, IItem } from "src/types";
import toast from "react-hot-toast";



export interface IRemitViewProps {
  spaceStore?:    SpaceStore,
  authStore?:     AuthStore,
  questionStore?: QuestionStore,
  delivStore?:    DeliverableStore,
  item:           Question | Deliverable,
}

export const RemitView = inject("spaceStore", "authStore", "questionStore", "delivStore")(observer((props: IRemitViewProps): JSX.Element => {
  const { item, spaceStore, authStore, questionStore, delivStore } = props;
  const { t, i18n } = useTranslation();
  const [remit,        setRemit]        = React.useState<boolean>(item.data_type === DataType.Question);
  const [selectedRoom, setSelectedRoom] = React.useState<{value: Space, label: string}>(null);

  const show_remit: boolean = item.data_type === DataType.Question;
  const projectRooms: Space[] = spaceStore.getProjectRooms(authStore.getCurProjectID).filter(r => r.id !== authStore.getCurRoomID);

  return (
    <Container>
      <Text>{t("remit_explanation", {context: item.data_type})}</Text>
      {show_remit && <Checkbox checked={remit} onClick={() => setRemit(!remit)} label={t("remit_question")} />}
      <Text>{t("meeting_room")}</Text>
      <MultiSelect 
        singleSelect
        closeOnSelect
        options  = {projectRooms.map(r => ({value: r, label: r.title}))}
        selected = {selectedRoom ? [selectedRoom] : []}
        onChange = {(selection) => setSelectedRoom(selection)}
      />
      <Button onClick={async () => {
        if(!await item.remit(selectedRoom.value.id, !remit)) {
          if(remit) toast.error(t("remitted_failed"));
          else toast.error(t("moved_failed", {type: item.data_type}));
        } else {
          if(remit) toast.success(t("remitted"));
          else toast.success(t("moved", {type: item.data_type}));
          if(item.data_type === DataType.Question) questionStore.setActive(null);
          else delivStore.setActive(null);
        }
      }}>
        {t("remit")}
      </Button>
    </Container>
  );
}));

const Container = styled.div`
  display:        flex;
  flex-direction: column;
  >* {
    margin-bottom: 1rem;
  }
`;